// extracted by mini-css-extract-plugin
export default {"container":"UnableToLoadData_container__aqBXn","message":"UnableToLoadData_message__Ah2Wb","topBorderOnError":"UnableToLoadData_topBorderOnError__yzXac"};